export default "__VITE_ASSET__1884c262__"